import { Component, Input } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { isPastCalendarDate, toLocalCalendarDate } from '../../utility';

/**
 * DOVE-2155 — inline confirmation shown when a user selects a past scheduled date.
 *
 * Mirrors the Client Portal's future-date validation style: an inline warning
 * block with a checkbox the user must tick to confirm the past date is intended.
 *
 * Presentational only. The parent form owns the `pastDateConfirmed` control and a
 * group validator (`pastScheduledDateConfirmationValidator`) that blocks submit
 * until the box is confirmed. The block only appears once the date control is
 * dirty, so it never shows for a pre-populated past date the user hasn't touched.
 */
@Component({
	selector: 'app-past-date-confirm',
	templateUrl: './past-date-confirm.component.html'
})
export class PastDateConfirmComponent {
	/** The parent form's scheduled-date control (read for value + dirty state). */
	@Input() dateControl!: AbstractControl | null;
	/** The parent form's `pastDateConfirmed` control the checkbox binds to. */
	@Input() confirmControl!: FormControl;
	/** DOM id for the checkbox/label pairing (unique per modal). */
	@Input() inputId = 'pastDateConfirm';

	/** Show the confirmation block only once the user has picked a past date. */
	get show(): boolean {
		const ctrl = this.dateControl;
		return !!ctrl && ctrl.dirty && isPastCalendarDate(ctrl.value);
	}

	get formattedDate(): string {
		const selected = toLocalCalendarDate(this.dateControl?.value);
		return selected ? selected.toLocaleDateString('en-US') : '';
	}
}
